// AppSelectionPage.jsx - Dedicated page for app selection after login
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Box } from "@mui/material";
import { useUser } from "./UserContextPersistent";
import HomeHeader from "../../components/header/homeHeader/HomeHeader";
import Footer from "../../components/common/Footer";
import AppSelectionModal from "./AppSelectionModal";

const AppSelectionPage = () => {
  const navigate = useNavigate();
  const { state } = useUser();
  const [organizationData, setOrganizationData] = useState(null);

  useEffect(() => {
    // Get organization data from context or localStorage
    let orgData = state.organization;

    if (!orgData) {
      try {
        const userState = JSON.parse(localStorage.getItem("userState"));
        orgData = userState?.organization;
      } catch (e) {
        console.error("Error parsing userState:", e);
      }
    }

    if (!orgData) {
      try {
        const storedOrg = localStorage.getItem("organization");
        if (storedOrg) {
          orgData = JSON.parse(storedOrg);
        }
      } catch (e) {
        console.error("Error parsing organization:", e);
      }
    }

    if (orgData) {
      setOrganizationData(orgData);
    }
  }, [state.organization]);

  const handleAppSelect = (app) => {
    localStorage.setItem("selectedApp", app.id);

    if (app.route.startsWith("/")) {
      navigate(app.route);
    } else {
      window.location.href = app.route;
    }
  };

  const handleCloseModal = () => {
    // If user tries to close, redirect to login
    navigate("/login");
  };

  return (
    <>
      <HomeHeader />
      <Container maxWidth="md" sx={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%" }}>
          <AppSelectionModal
            open={true}
            onClose={handleCloseModal}
            onAppSelect={handleAppSelect}
            organizationData={organizationData}
          />
        </Box>
      </Container>
      <Footer isLogin={true} />
    </>
  );
};

export default AppSelectionPage;
